// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Link from "../Link.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as ItemName from "common/src/tft-static/ItemName.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as StatsConfig from "../stats/StatsConfig.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as StatsOverview from "./StatsOverview.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as UnitSynergiesTable from "../units/UnitSynergiesTable.bs.js";
import * as TraitSynergiesTable from "../units/TraitSynergiesTable.bs.js";
import IconButton from "@mui/material/IconButton";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Item");
        }), undefined, (function (v, param, param$1) {
          return React.createElement(Link.make, {
                      route: {
                        TAG: /* Stats */0,
                        _0: {
                          TAG: /* Item */6,
                          id: v.id,
                          aperture: param$1.aperture
                        }
                      },
                      children: React.createElement("div", {
                            className: "flex items-center text-sm"
                          }, React.createElement("div", {
                                className: "flex-shrink-0"
                              }, React.createElement(ItemImage.make, {
                                    itemId: v.id,
                                    size: 27,
                                    rounded: "rounded"
                                  })), React.createElement("div", {
                                className: "pl-2 font-normal font-roboto truncate"
                              }, React.createElement(ItemName.make, {
                                    itemId: v.id
                                  })))
                    });
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return param$1.itemsT(v.id);
        }), undefined, 200, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Play rate");
        }), undefined, (function (v, totCount, param) {
          return React.createElement(Tooltip.make, {
                      title: T.humanReadableCount(v.count) + " games",
                      children: React.createElement("div", undefined, Global.formatPct(undefined, Global.f(v.count) / Global.f(totCount)) + "%")
                    });
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.count;
        }), undefined, 106, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixed(undefined, v.place);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.place;
        }), undefined, 76, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Delta");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixedSign(undefined, v.delta2);
        }), undefined, undefined, Caml_option.some(Tooltip.delta), (function (v, param, param$1) {
          return v.delta2;
        }), undefined, 76, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Rel. Delta");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixedSign(undefined, v.delta);
        }), undefined, undefined, Caml_option.some(Tooltip.relDelta), (function (v, param, param$1) {
          return v.delta;
        }), undefined, 90, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4") + " %";
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct3(v.top4);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.top4;
        }), undefined, 96, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win") + " %";
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct3(v.won);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.won;
        }), undefined, 80, undefined, undefined)
];

function ItemPage$ItemsList(Props) {
  var data = Props.data;
  var totCount = Props.totCount;
  var keyFn = React.useCallback((function (v) {
          return v.id;
        }), []);
  return React.createElement(StatsTable2.make, {
              cols: cols,
              data: data,
              context: totCount,
              keyFn: keyFn,
              stickyColCount: 1,
              defaultSortIdx: 1
            });
}

var ItemsList = {
  cols: cols,
  make: ItemPage$ItemsList
};

function ItemPage(Props) {
  var statsData = Props.statsData;
  var itemData = Props.itemData;
  var itemId = Props.itemId;
  var aperture = Props.aperture;
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return /* Units */0;
      });
  var setTab = match[1];
  var tab = match[0];
  var tmp;
  switch (tab) {
    case /* Units */0 :
        tmp = React.createElement(UnitSynergiesTable.make, {
              units: itemData.units,
              totCount: itemData.base.count,
              inContext: false
            });
        break;
    case /* Traits */1 :
        tmp = React.createElement(TraitSynergiesTable.make, {
              traits: itemData.traits,
              totCount: itemData.base.count,
              inContext: false
            });
        break;
    case /* Items */2 :
        tmp = React.createElement(ItemPage$ItemsList, {
              data: itemData.items,
              totCount: itemData.base.count
            });
        break;
    
  }
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(StatsConfig.make, {}), React.createElement(StatsConfig.Context.make, {
                  children: React.createElement(ContentSection.make, {
                        className: "pt-2 sm:w-[800px]",
                        children: null,
                        noPadding: true
                      }, React.createElement("div", {
                            className: "pt-2 flex items-center"
                          }, React.createElement("div", {
                                className: "pl-2 pr-1 md:pr-2"
                              }, React.createElement(Link.make, {
                                    route: {
                                      TAG: /* Stats */0,
                                      _0: {
                                        TAG: /* Items */2,
                                        aperture: aperture
                                      }
                                    },
                                    children: React.createElement(IconButton, {
                                          onClick: (function (param) {
                                              
                                            }),
                                          size: "small",
                                          children: React.createElement(ArrowBackIos, {
                                                fontSize: "small"
                                              })
                                        })
                                  })), React.createElement(ItemImage.make, {
                                itemId: itemId,
                                size: 30,
                                rounded: "rounded"
                              }), React.createElement("h4", {
                                className: "pl-1 text-base"
                              }, React.createElement(ItemName.make, {
                                    itemId: itemId
                                  }))), React.createElement(StatsOverview.make, {
                            count: itemData.base.count,
                            place: itemData.base.place,
                            top4: itemData.base.top4,
                            won: itemData.base.won,
                            plDist: itemData.placeDistribution,
                            regionDist: itemData.regionStats,
                            fullCount: statsData.totalEntries
                          }), React.createElement(Tabs, {
                            children: null,
                            value: tab,
                            onChange: (function (param, t) {
                                return Curry._1(setTab, (function (param) {
                                              return t;
                                            }));
                              })
                          }, React.createElement(Tab, {
                                label: t("Units"),
                                value: /* Units */0
                              }), React.createElement(Tab, {
                                label: t("Traits"),
                                value: /* Traits */1
                              }), React.createElement(Tab, {
                                label: t("Items"),
                                value: /* Items */2
                              })), tmp)
                }));
}

var make = ItemPage;

export {
  ItemsList ,
  make ,
  
}
/* cols Not a pure module */
